import { FishingMinigame, FISH_TIMEOUT } from '@phaser/minigames/fishing';
import { DEPTH } from '@phaser/data/depth';
import { Game } from '@phaser/scenes/Game';
import * as Shared from '@shared/lib';

export class Fish {
  public spawnedAt: number;
  public strength: number;
  public keyId: number;
  public key: string;
  public id: string;
  public x: number;
  public y: number;

  private _fishing: FishingMinigame;
  private _scene = Game.current;
  private _despawnTimer: Timer;

  private _container: Phaser.GameObjects.Container;
  private _fishInner: Phaser.GameObjects.Arc;
  private _despawnTween: Phaser.Tweens.Tween;

  constructor(
    fishing: FishingMinigame,
    id: string,
    fish: Shared.FishData,
    x: number,
    y: number
  ) {
    this.strength = fish.strength;
    this.spawnedAt = Date.now();
    this.keyId = fish.id;
    this.key = fish.key;
    this.id = id;
    this.x = x;
    this.y = y;

    this._fishing = fishing;

    this._spawnIn(x, y);
    this._startDespawn();
  }

  public destroy() {
    this._container.destroy();
  }

  private _spawnIn(x: number, y: number) {
    this._container = this._scene.add.container(x, y)
      .setDepth(DEPTH.MINIGAME);

    const fish = this._container.scene.add.circle(0, 0, 28, 0xFFFFFF, 0.3)
      .setOrigin(0.5)
      .setInteractive();
    this._container.add(fish);

    this._fishInner = this._container.scene.add.circle(0, 0, 28, 0xFFFFFF, 0.4)
      .setOrigin(0.5);
    this._container.add(this._fishInner);

    const hook = this._scene.add.image(0, 0, 'sprites', 'fishinghook');
    this._container.add(hook);

    fish.on('pointerdown', () => {
      this._fishing.onPointerDown(this.id);
      clearTimeout(this._despawnTimer);
      this._despawnTween.stop();
    });
    fish.on('pointerup', () => {
      this._fishing.onPointerUp(this.id);
    });

    this._scene.tweens.add({
      targets: [fish, this._fishInner],
      scale: { from: 0, to: 1 },
      duration: 300,
      ease: 'Power2',
    });
  }

  private _startDespawn() {
    this._despawnTimer = setTimeout(() => {
      this._fishing.stopFishing(this.id);
    }, FISH_TIMEOUT);

    this._despawnTween = this._scene.tweens.add({
      targets: this._fishInner,
      scale: { from: 1, to: 0 },
      duration: FISH_TIMEOUT,
    });
  }
}